import { routerActionCreators } from '@opengov/compose-app-router/state';

import {
  createFromTemplatePath,
  draftListPath,
  folderListPath,
  onlinePublicatioSelectMenuPath,
  organizeSectionAndStoriesPath,
  organizeStoriesAndFoldersPath,
  previewOnlinePublicatioPath,
  publicationCustomCssPath,
  publicationCustomReportPath,
  publicationFolderListPath,
  publicationListPath,
  publicationReportEmbedsPath,
  publicationSetupPDFPath,
  publicationStoryEditPath,
  publicationStorySetupPDFPath,
  publicationStoryViewPath,
  publicationTemplateListPath,
  publicationViewPath, sectionSetupPDFPath,
  setupOnlinePublicatioPath,
  setupOnlinePublicatioSelectTabPath,
  storiesSettingsPath,
  storyEditPath,
  storyListPath,
  storySetupPDFPath,
  storyViewPath,
  templateListPath
} from '../../routes/paths';

export const navigateToSettings = (entitySubdomain: string, tab?: string) =>
  routerActionCreators.push(storiesSettingsPath(entitySubdomain, tab));

export const navigateToDraftList = (entitySubdomain: string) =>
  routerActionCreators.push(draftListPath(entitySubdomain));

export const navigateToStoryList = (entitySubdomain: string) =>
  routerActionCreators.push(storyListPath(entitySubdomain));

export const navigateToStoryView = (entitySubdomain: string, storyId: string, isTemplate = false) =>
  routerActionCreators.push(storyViewPath(entitySubdomain, storyId, isTemplate));

export const navigateToStoryEdit = (entitySubdomain: string, storyId: string, isTemplate = false) =>
  routerActionCreators.push(storyEditPath(entitySubdomain, storyId, isTemplate));

export const navigateToPublicationStoryEditPath = (
  entitySubdomain: string,
  storyId: string,
  isTemplate = false,
  publicationId: string
) => routerActionCreators.push(publicationStoryEditPath(entitySubdomain, storyId, isTemplate, publicationId));

export const navigateToCreateFromTemplate = (entitySubdomain: string) =>
  routerActionCreators.push(createFromTemplatePath(entitySubdomain));

export const navigateToTemplateList = (entitySubdomain: string) =>
  routerActionCreators.push(templateListPath(entitySubdomain));

export const navigateToFolderList = (entitySubdomain: string, folderId: string) => {
  return routerActionCreators.push(folderListPath(entitySubdomain, folderId));
};

export const navigateToOrganizeStoriesAndFolders = (entitySubdomain: string, folderId: string, rootId: string) =>
  routerActionCreators.push(organizeStoriesAndFoldersPath(entitySubdomain, folderId, rootId));

export const navigateToPublicationList = (entitySubdomain: string) =>
  routerActionCreators.push(publicationListPath(entitySubdomain));

export const navigateToPublicationView = (entitySubdomain: string, publicationId: string) =>
  routerActionCreators.push(publicationViewPath(entitySubdomain, publicationId));

export const navigateToPublicationReportsView = (entitySubdomain: string, publicationId: string) =>
  routerActionCreators.push(publicationReportEmbedsPath(entitySubdomain, publicationId));

export const navigateToPublicationCustomReportsView = (entitySubdomain: string, publicationId: string) =>
  routerActionCreators.push(publicationCustomReportPath(entitySubdomain, publicationId));

export const navigateToPublicationCustomCssView = (entitySubdomain: string, publicationId: string, storyId?: string) =>
  routerActionCreators.push(publicationCustomCssPath(entitySubdomain, publicationId, storyId));

export const navigateToCreateFromTemplateInPublication = (entitySubdomain: string, publicationId: string) =>
  routerActionCreators.push(publicationTemplateListPath(entitySubdomain, publicationId));

export const navigateToPublicationStoryView = (
  entitySubdomain: string,
  storyId: string,
  isTemplate: boolean,
  publicationId: string
) => routerActionCreators.push(publicationStoryViewPath(entitySubdomain, storyId, isTemplate, publicationId));

export const navigateToPublicationFolderList = (entitySubdomain: string, publicationId: string, sectionId: string) =>
  routerActionCreators.push(publicationFolderListPath(entitySubdomain, publicationId, sectionId));

export const navigateToOrganizeSectionAndStoriesPath = (
  entitySubdomain: string,
  publicationId: string,
  sectionId: string,
  selectedSectionId: string
) =>
  routerActionCreators.push(
    organizeSectionAndStoriesPath(entitySubdomain, publicationId, sectionId, selectedSectionId)
  );

export const navigateToPreviewOnlinePublication = (entitySubdomain: string, publicationId: string) =>
  window.open(previewOnlinePublicatioPath(entitySubdomain, publicationId), '_blank');

export const navigateToPublicationViewNewTab = (
  entitySubdomain: string,
  publicationId: string,
  copyPublicationJobId: string
) => window.open(publicationViewPath(entitySubdomain, publicationId, copyPublicationJobId), '_blank');

export const navigateToSetupOnlinePublication = (entitySubdomain: string, publicationId: string) =>
  routerActionCreators.push(setupOnlinePublicatioPath(entitySubdomain, publicationId));

export const navigateToSetupOnlinePublicationTab = (entitySubdomain: string, publicationId: string, tabId: string) =>
  routerActionCreators.push(setupOnlinePublicatioSelectTabPath(entitySubdomain, publicationId, tabId));

export const navigateToOnlinePublicationMenu = (entitySubdomain: string, publicationId: string, menuId: string) =>
  routerActionCreators.push(onlinePublicatioSelectMenuPath(entitySubdomain, publicationId, menuId));

export const navigateToPublicationSetupPDF = (entitySubdomain: string, publicationId: string) =>
  routerActionCreators.push(publicationSetupPDFPath(entitySubdomain, publicationId));

export const navigateToSectionSetupPDF = (entitySubdomain: string, sectionId: string) =>
  routerActionCreators.push(sectionSetupPDFPath(entitySubdomain, sectionId));
export const navigateToStorySetupPDF = (entitySubdomain: string, storyId: string) =>
  routerActionCreators.push(storySetupPDFPath(entitySubdomain, storyId));

export const navigateToPublicationStorySetupPDF = (entitySubdomain: string, storyId: string, publicationId: string) =>
  routerActionCreators.push(publicationStorySetupPDFPath(entitySubdomain, storyId, publicationId));
